<template lang="pug">
  include /mixins
  +b.tt-checkout-detail-info(
    v-if='initial.shipping_service && initial.shipping_service.id && showForm'
  )
    +e.title.P {{ _('Способ оплаты') }}
    +e.content
      +b.variants-view(
      )
        //- +e.title
        //-   +b.variants-title
        //-     +e.icon.mdi.mdi-chevron-right
        //-     +e.text.P {{ _('Выберите удобный способ оплаты') }}

        +e.list
          +b.g-row
            +b.g-cell.g-cols--12(
              :class='`g-cols--${payment_config.size}-xl`'

            )
              validation-provider(
                :rules='{ required: { allowFalse: false } }',
                v-slot="{ errors, classes }"
                name='payment_gateway'
              )
                .relative
                  +b.error-label.LABEL(v-if="errors[0]") {{ errors[0] }}
                v-selection-controller(
                  :options='payment_config.props.options'
                  :multiple='false',
                  :key-getter="$options.keyGetter",
                  v-model='form[payment_config.name]'
                  v-slot="{ options, value: model, change }"
                )
                  div
                    +b.d-control-input.tt-space_mb--5(
                      v-for='{ value }, idx in options'
                    )
                      +e.element.INPUT.order-address-card-input(
                        type='radio'
                        name='payment'
                        :value='value'
                        :checked='form[payment_config.name] == value'
                        :ref='`payment`'
                        @change='change(value); $emit("update", form);'
                        :input-label='value.title',
                        :id='`payment:${value.id}`'
                        :key='`payment:${value.id}`'
                      )
                      +e.LABEL.label--static.order-address-card-label(
                        :for='`payment:${value.id}`'
                      )
                        +b.order-address-select.P {{ value && value.props && value.props.title }}
              //- tag(
              //-   :tag='payment_config.tag'
              //-   v-model='form[payment_config.name]'
              //-   :input-label='payment_config.title',
              //-   :rules='payment_config.rules'
              //-   v-bind='payment_config.props'
              //-   v-on='payment_config.events'
              //-   :name='payment_config.name'
              //- )
              //- v-if='payment_config.props.options.length == 1'
              //- +b.da-caption--size_sm.P(
              //- ) {{ _('Способы оплаты не доступны') }}
              //- v-if='!payment_config.props.options.length'
              //- +b.da-caption--size_sm.P(
              //- ) {{ _('Способы оплаты не доступны') }}
              +b.ds-caption.--size_xs.P(
                v-if='showDesc'
              ) {{ _('* Реквізити для оплати будуть доступні після оформлення замолення') }}

</template>

<script>
import pathOr from 'ramda/src/pathOr'
import {
  getPayments,
} from '@api/order.service'

const PAYMENT_METHOD_WITH_DESC = 'prepayment_account'

const { isPreorder } = window

export default {
  name: 'OrderPayment',
  keyGetter: x => `${x.type}:${x.id}`,
  props: {
    initial: {},
    bonusesInfo: {
      default: () => ({ need_payment_gateway: true }),
    },
  },
  data() {
    return {
      initOption: {
        $isDisabled: true,
        caption: this._('-выберите'),
      },
      variants: [],
      payment_config: {
        size: '12',
        title: this._('payment service'),
        rules: 'required',
        name: 'payment_gateway',
        tag: 'd-control-multiselect',
        events: {
          input: () => this.$emit('update', this.form),
        },
        props: {
          options: [],
          label: 'caption',
        },
      },
      form: {
        payment_gateway: '',
      },
    }
  },
  computed: {
    showForm() {
      return this.bonusesInfo && this.bonusesInfo.need_payment_gateway
    },
    showDesc() {
      return pathOr(null, ['props', 'service', 'value'], this.form.payment_gateway) === PAYMENT_METHOD_WITH_DESC
    },
  },
  watch: {
    'initial.shipping_service': {
      handler() {
        this.form.payment_gateway = ''
        this.getPaymentsVariants()
      },
    },
  },
  created() {
  },
  methods: {
    async getPaymentsVariants() {
      const shipping_services = this.initial.shipping_service.id
      const params = isPreorder ? { available_for_preorder: true, shipping_services } : { shipping_services }
      const { data: { items } } = (await getPayments
        .execute(params))
      this.payment_config.props.options = items
      // this.payment_config.props.options.unshift(this.initOption)
    },
  },
}
</script>
